const isRetina = function() {
  return (window.devicePixelRatio > 1);
}

const retinaURL = function(url) {
  return url.replace(/(\.[a-z]{3})$/, "@2x$1");
}

const optimalResURL = function(url) {
  if (isRetina(url)) return retinaURL(url);
  return url;
}

const optimalResURLFromMap = function(data = Map()) {
  if (data.get("retina", true) === false) return data.get("url");
  return optimalResURL(data.get("url"));  
}

module.exports.isRetina = isRetina;
module.exports.retinaURL = retinaURL;
module.exports.optimalResURL = optimalResURL;
module.exports.optimalResURLFromMap = optimalResURLFromMap;
